"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RICH_TEXT_STYLE_PROPS = void 0;
exports.RICH_TEXT_STYLE_PROPS = ['color', 'font-size'];
